import SubcategoryPage from '@/components/template/SubcategoryPage';

const Adirondack = () => {
  const products = [
    {
      title: "Adirondack Classic",
      imageSrc: "https://images.unsplash.com/photo-1533090161767-e6ffed986c88?auto=format&fit=crop&q=80",
      url: "/proizvodi/adirondack-classic"
    },
    {
      title: "Adirondack Modern",
      imageSrc: "https://images.unsplash.com/photo-1616486029423-aaa4789e8c9a?auto=format&fit=crop&q=80",
      url: "/proizvodi/adirondack-modern"
    },
    {
      title: "Adirondack Premium",
      imageSrc: "https://images.unsplash.com/photo-1533090161767-e6ffed986c88?auto=format&fit=crop&q=80&w=1200",
      url: "/proizvodi/adirondack-premium"
    }
  ];

  return (
    <SubcategoryPage
      title="Adirondack"
      description="Klasični in udobni Adirondack stoli, ki združujejo tradicijo in kakovost za popolno sproščanje."
      heroImage="https://images.unsplash.com/photo-1533090161767-e6ffed986c88?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default Adirondack;